import React, { useEffect } from 'react'
import '../About.scss'
import '../../../App.scss'
import { Col, Container, Row, Button } from 'react-bootstrap'

const Careers = (): JSX.Element => {
  useEffect(() => {
    console.log('Rendering <Careers />')
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="About">
      <div className="s1">
        <h1>Career Opportunities at Challenge</h1>
      </div>
      <div className="s2">
        <Container>
          <Row className="justify-content-center">
            <Col lg={7} className="CareersCol">
              <h2>Current Positions Available</h2>
              <p>&nbsp;</p>
              {
                <p>
                  We appreciate your interest in joining Team Challenge. While
                  there are no open positions at this time, we encourage you to
                  revisit this page regularly to view newly posted
                  opportunities.
                </p>
              }
              {/*}
              <h4>Marketing Specialist</h4>
              <p>
                The Marketing Specialist supports revenue growth by planning and
                executing marketing initiatives that generate leads, strengthen
                brand awareness, and showcase The Challenge Machinery Company’s
                capabilities across a range of bindery finishing solutions. You
                will own key channels and campaigns end-to-end—turning ideas
                into measurable results.
              </p>
              <p>
                <a
                  href={`/jobs/Marketing_Specialist.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button>Information</Button>
                </a>
                &nbsp;
                <a href="mailto:jobs@challengemachinery.com?subject=Marketing Specialist Position">
                  <Button>Apply</Button>
                </a>{' '}
                or call Challenge at: 231-799-8484 ext. 221
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <h4>Plant Controller</h4>
              <p>
                The Plant Controller oversees all financial operations, cost
                accounting, and budgeting in a manufacturing environment, acting
                as a key business partner to management to improve profitability
                and efficiency. They are responsible for monthly financial
                reporting, inventory valuation, internal controls, and variance
                analysis. Typically, this role requires a bachelor's degree in
                accounting/finance, 5+ years of experience, and strong
                ERP/Excel/QB skills.
              </p>
              <p>
                <a
                  href={`/jobs/Plant_Controller.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button>Information</Button>
                </a>
                &nbsp;
                <a href="mailto:jobs@challengemachinery.com?subject=Plant Controller Position">
                  <Button>Apply</Button>
                </a>{' '}
                or call Challenge at: 231-799-8484 ext. 221
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <h4>Sales Operations Coordinator</h4>
              <p>
                The Sales Operations Coordinator streamlines the sales process
                by managing CRM data, generating reports, processing orders, and
                providing administrative support to sales teams. They enhance
                efficiency by maintaining data accuracy, coordinating sales
                collateral, assisting with onboarding, and ensuring compliance
                with policies to help sales reps focus on closing deals.
              </p>
              <p>
                <a
                  href={`/jobs/Sales_Operations_Coordinator.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button>Information</Button>
                </a>
                &nbsp;
                <a href="mailto:jobs@challengemachinery.com?subject=Sales Operations Coordinator Position">
                  <Button>Apply</Button>
                </a>{' '}
                or call Challenge at: 231-799-8484 ext. 221
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              {/*
              <h4>JOB TITLE</h4>
              <p>Major Objective</p>
              <ul>
                <li>
                  text
                </li>
              </ul>
              <p>Major Responsibilities</p>
              <ul>
                <li>
                  text
                </li>
                <li>text</li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
                <li>text </li>
              </ul>
              <p>
                To apply, email:{' '}
                <a href="mailto:jobs@challengemachinery.com">
                  jobs@challengemachinery.com
                </a>{' '}
                or call Challenge at: 231-799-8484
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              */}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default Careers
